<template>
  <div>
    <template v-if="ifImage">
      <div class="block">
        <div class="bg-image"></div>
        <div class="blur_bg">
          <img :src="imgUrl" />
          <div style="display: flex; justify-content: center">
            <CRow>
              <div class="btn_next">
                <CCol col="12">
                  <div style="font-size: 18px">NEXT</div>
                </CCol>
              </div>
            </CRow>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="block">
        <div class="bg-image"></div>
        <div class="blur_bg">
          <h2 class="font_size">
            {{ message }}
          </h2>
          <!-- <p style="font-size: 20px">
            {{ description }}
          </p> -->
          <p style="font-size: 18px; color: darkblue" v-if="showWarning">
            {{ scoreStatusText({previousScore, maxScore}) }}
          </p>
          <div style="display: flex; justify-content: center">
            <div v-show="showbtn" class="btn_finish" @click="onClickBtn()">
              <img
                style="width: 40px; height: 40px"
                src="/icons/trophy.svg"
              />
              <div
                style="font-size: 18px; text-align: center; margin-left: 10%"
              >
                FINISH
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ButtonIcon from '../../../../components/elements/Buttons/ButtonIcon.vue';
import TEMPLATE from '../../../../TEMPLATE.vue';
export default {
  components: {ButtonIcon, TEMPLATE},
  name: 'Finish',
  props: {
    message: {
      type: String,
    },
    iconUrl: {
      type: String,
    },
    showbtn: {
      type: Boolean,
    },
    imgUrl: {
      type: String,
    },
    ifImage: {
      type: Boolean,
    },
    showWarning: {
      type: Boolean,
    },
    previousScore: {type: Number},
    maxScore: {type: Number},
  },
  data() {
    return {
      trophy: '/icons/trophy.svg',
      // used for declare local variable to use in this class
      // Syntax : Name of variable : Default value
      // Example => courses: []
      lang: this.$store.getters['language/getLanguage'],
    };
  },
  methods: {
    onClickBtn: function () {
      this.$emit('nextRoute');
    },
    // used for define functions in each case
    // Syntax : Name of method(){ Actions }
    // Example => onLogin(){ this.$store.dispatch('auth/onLogin') }
    scoreStatusText(val) {
      //input lang to return text
      if (this.lang == 'TH') {
        return `*คุณได้ทำแบบทดสอบนี้ไปแล้ว และคะแนนการทำครั้งแรกของคุณคือ ${val.previousScore}/${val.maxScore}`;
      } else {
        return `*You’ve already finished this test and Your first attempt score
 is ${val.previousScore}/${val.maxScore}`;
      }
    },
  },
  computed: {
    // used for detect data, in this project usually detect the response data from API
    // that collect in the getters of store (vuex)
    // bringing mapGetters to detect in getters of store (vuex)
    // syntax : ...mapGetters({ Name created variable for local data : Name of getters in store })
    // Example => ...mapGetters({ courses : 'courses/allCourses' })
    storeLang() {
      return this.$store.getters['language/getLanguage'];
    },
  },
  watch: {
    // used to manage data after detect data
    // Syntax : Existing name of local variable : function(value){ Action }
    // Example => course : function(value){ this.data = value }
    // Value in parameter is the value of detected data changing
    storeLang(val) {
      this.lang = val;
    },
  },
  created() {
    // used for manage event when this page open
  },
  mounted() {
    // used for manage event when data has changed
    this.lang = this.$store.state.language.language;
  },
  beforeDestroy() {
    // used for update value before close this page
    // สมมติว่าจับเวลาใช้ในหน้านี้กี่นาที ให้มาเก็บในนี้
  },
};
</script>

<style scoped lang="scss">
.block {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: 7px;
}
.font_size {
  display: flex;
  justify-content: center;
  font-size: 120px;
}
.bg-image {
  background-image: linear-gradient(90deg, #ffdc77 0%, #fff 50%, #ffccd5 100%);
  /* Add the blur effect */
  filter: blur(8px);
  -webkit-filter: blur(8px);

  /* Full height */
  width: 1920px;
  height: 1080px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.blur_bg {
  font-weight: bold;
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%);
  z-index: 2;
  text-align: center;
}

.btn_finish {
  margin-top: 10%;
  position: relative;
  width: 200px;
  height: 60px;
  display: flex;
  padding: 2%;
  justify-content: center;
  align-items: center;
  background-color: #f1b205;
  color: white;
  text-decoration: none;
  font-size: 12px;
  border-radius: 10px !important;
  box-shadow: none;
  cursor: pointer;
  margin-bottom: 20%;
}

.btn_next {
  width: 200px;
  height: 70px;
  background-color: #89abe6;
  color: white;
  text-align: center;
  text-decoration: none;
  font-size: 18px;
  border-radius: 8px !important;
  box-shadow: none;
  margin-top: 6%;
  margin-bottom: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  .bg-image {
    height: 700px;
  }
  .font_size {
    font-size: 80px;
  }
}
</style>
